import * as React from "react";
import * as ReactDOM from "react-dom";
import { LabelColor } from "./";

interface IProperties
{
    /**
     * Enthält das gebundene Objekt zu diesem Label.
     */
    dataSource?: any,

    /**
     * Anzeige Text.
     */
    text?: string,

    /**
     * Die Farbe des Labels.
     */
    color?: LabelColor | string,

    /**
     * Gibt an ob der Button des Labels sichtbar ist.
     */
    isButtonVisible?: boolean,

    /**
     * Wird ausgeführt, sobald auf das Label geklickt wird.
     */
    onClick?: (dataSource?: any) => void,

    /**
     * Wird ausgeführt, sobald auf den Button des Labels geklickt wird.
     */
    onButtonClick?: (dataSource?: any) => void
}

export class Label extends React.Component<IProperties>
{
    /**
     * Standardwerte setzen.
     */
    public static defaultProps: Partial<IProperties> = {
        color: LabelColor.none,
        isButtonVisible: false
    };

    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        this.props.onClick && this.props.onClick(this.props.dataSource);
    }

    /**
     * Führt die "onButtonClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onButtonClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        this.props.onButtonClick && this.props.onButtonClick(this.props.dataSource);
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { text, color, isButtonVisible } = this.props;

        var classNames: string[] = ["label"];
        classNames.push("label--" + color);

        var button: JSX.Element = null;
        if (isButtonVisible)
        {
            button = (
                <div
                    className="label_btn"
                    onClick={this.onButtonClick}>
                    <i className="mdi mdi-close"></i>
                </div>
            );
        }

        return (
            <div
                className={classNames.join(" ")}
                onClick={this.onClick}>
                {
                    text != null &&
                    <div className="label_text">
                        {text}
                    </div>
                }
                {button}
            </div>
        );
    }
}